export default __webpack_public_path__ + "static/media/ic_empty_briks.e93063ff.svg";